import { ActiveModelSerializer } from 'active-model-adapter';
import DS from 'ember-data';
import { ObjectIdentifierKey } from 'cio/utils/identifiers';
import { ModelRegistry } from 'ember-data/model';

const { EmbeddedRecordsMixin } = DS;

export default class ObjectSerializer extends ActiveModelSerializer.extend(EmbeddedRecordsMixin, {
  isNewSerializerAPI: true,
}) {
  serialize(snapshot: DS.Snapshot, options: Record<string, any>) {
    let json = super.serialize(snapshot, options) as Record<string, any>;

    if (json[ObjectIdentifierKey.ObjectId] == null) {
      json[ObjectIdentifierKey.ObjectId] = json.attributes[ObjectIdentifierKey.ObjectId];
    }

    let { record } = snapshot;
    let hiddenAttributes = (record as ModelRegistry['object']).get('hiddenAttributes') ?? [];

    // We want to set attributes to an empty string.
    // In the API an empty string is the same as deleting an attribute
    if (hiddenAttributes.length > 0) {
      hiddenAttributes.forEach((item: string) => {
        json.attributes[item] = '';
      });
    }

    return json;
  }
}
